var manifest = [{
  stem: "analyst_report",
  icon: "AnalystReport"
}, {
  stem: "avatar",
  icon: "Avatar"
}, {
  stem: "calculator",
  icon: "Calculator"
}, {
  stem: "click",
  icon: "Click"
}, {
  stem: "close",
  icon: "Close"
}, {
  stem: "contact_sales",
  icon: "ContactSales"
}, {
  stem: "contact_us",
  icon: "ContactUs"
}, {
  stem: "disable",
  icon: "Disable"
}, {
  stem: "down",
  icon: "Down"
}, {
  stem: "download",
  icon: "Download"
}, {
  stem: "enter",
  icon: "Enter"
}, {
  stem: "error",
  icon: "Error"
}, {
  stem: "facebook-o",
  icon: "FacebookO"
}, {
  stem: "facebook",
  icon: "Facebook"
}, {
  stem: "fold",
  icon: "Fold"
}, {
  stem: "global",
  icon: "Global"
}, {
  stem: "hover",
  icon: "Hover"
}, {
  stem: "info",
  icon: "Info"
}, {
  stem: "insights",
  icon: "Insights"
}, {
  stem: "language",
  icon: "Language"
}, {
  stem: "left",
  icon: "Left"
}, {
  stem: "linkedin-o",
  icon: "LinkedinO"
}, {
  stem: "linkedin",
  icon: "Linkedin"
}, {
  stem: "location",
  icon: "Location"
}, {
  stem: "menu-sub",
  icon: "MenuSub"
}, {
  stem: "menu",
  icon: "Menu"
}, {
  stem: "mouse",
  icon: "Mouse"
}, {
  stem: "not_all_selected",
  icon: "NotAllSelected"
}, {
  stem: "notify",
  icon: "Notify"
}, {
  stem: "num-eight",
  icon: "NumEight"
}, {
  stem: "num-five",
  icon: "NumFive"
}, {
  stem: "num-four",
  icon: "NumFour"
}, {
  stem: "num-nine",
  icon: "NumNine"
}, {
  stem: "num-one",
  icon: "NumOne"
}, {
  stem: "num-seven",
  icon: "NumSeven"
}, {
  stem: "num-six",
  icon: "NumSix"
}, {
  stem: "num-two",
  icon: "NumTwo"
}, {
  stem: "num-zero",
  icon: "NumZero"
}, {
  stem: "player",
  icon: "Player"
}, {
  stem: "press_center",
  icon: "PressCenter"
}, {
  stem: "product_updates",
  icon: "ProductUpdates"
}, {
  stem: "radio-disable",
  icon: "RadioDisable"
}, {
  stem: "radio-hover",
  icon: "RadioHover"
}, {
  stem: "radio-selected-disable",
  icon: "RadioSelectedDisable"
}, {
  stem: "radio-selected",
  icon: "RadioSelected"
}, {
  stem: "radio-unselected",
  icon: "RadioUnselected"
}, {
  stem: "right",
  icon: "Right"
}, {
  stem: "search",
  icon: "Search"
}, {
  stem: "selected-disable",
  icon: "SelectedDisable"
}, {
  stem: "selected",
  icon: "Selected"
}, {
  stem: "success",
  icon: "Success"
}, {
  stem: "success_o",
  icon: "SuccessO"
}, {
  stem: "three",
  icon: "Three"
}, {
  stem: "twitter-o",
  icon: "TwitterO"
}, {
  stem: "twitter",
  icon: "Twitter"
}, {
  stem: "unfold",
  icon: "Unfold"
}, {
  stem: "unselected",
  icon: "Unselected"
}, {
  stem: "up",
  icon: "Up"
}, {
  stem: "warning",
  icon: "Warning"
}, {
  stem: "webinar",
  icon: "Webinar"
}, {
  stem: "wechat",
  icon: "Wechat"
}, {
  stem: "whitepaper",
  icon: "Whitepaper"
}];

export { manifest };
//# sourceMappingURL=manifest.js.map
